import { useCallback } from 'react';
import { createSearchParams } from '../utils/helpers';


export const useDataPointHandler = ({
    categories,
    filters,
    handleFilterChange,
    UserData,
    fetchCategories,
    fetchSemanticRCA2,
    saveToHistory,
    setIsLoading,
    setTotalCounts
}) => {
    const handleDataPointClick = useCallback(async (_, __, config) => {
        setIsLoading(true);
        try {
            let categoryData = Object.entries(categories)[config.dataPointIndex];
            console.log("categoryData", categoryData)
            if (!categoryData) return;

            handleFilterChange('query', categoryData[1].prompt);
            handleFilterChange('title', categoryData[0]);
            const data = await fetchSemanticRCA2({
                ...filters,
                query: categoryData[1].prompt,
                complaintNumbers: categoryData[1].complaintNumbers
            });
            setTotalCounts(categoryData[1].count);
            if (data.complaintNumbers && data.complaintNumbers.length > 0) {
                UserData(data.complaintNumbers || ["NA"]);
                handleFilterChange('complaintNumbers', data.complaintNumbers || ["NA"]);
                categoryData[1].complaintNumbers = data.complaintNumbers || ["NA"];
            }
            // categoryData[1].total_counts = data.total_counts;

            const newFilters = {
                ...filters,
                query: categoryData[1].prompt,
                complaintNumbers: categoryData[1].complaintNumbers || ["NA"]
            };

            await fetchCategories(categoryData, newFilters);

            const searchParams = {
                ...createSearchParams({ ...filters, query: categoryData[1].prompt, title: categoryData[0] }),
                complaint_numbers: categoryData[1].complaintNumbers || ["NA"]
            };
            searchParams.total_counts = categoryData[1].count;
            searchParams.prompt = categoryData[1].prompt;
            saveToHistory(searchParams);
        } catch (error) {
            console.error('Error handling category click:', error);
        } finally {
            setIsLoading(false);
        }
    }, [
        categories,
        filters,
        handleFilterChange,
        UserData,
        fetchCategories,
        fetchSemanticRCA2,
        saveToHistory,
        setIsLoading,
        setTotalCounts
    ]);

    return { handleDataPointClick };
};